import { render, staticRenderFns } from "./DeclaracaoSubstituicao.vue?vue&type=template&id=5701af9b&scoped=true&"
import script from "./DeclaracaoSubstituicao.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoSubstituicao.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoSubstituicao.vue?vue&type=style&index=0&id=5701af9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701af9b",
  null
  
)

export default component.exports